import React, { FunctionComponent } from 'react';
import packageStaticProps from '@/utility/nextJs/packageStaticProps';
import PageSeo from '@/components/seo/PageSeo';
import BarHeaderLayout from '@/pages/layouts/BarHeaderLayout';
import { getLandingPageEvents } from '@/pageGeneration/services/prismicApi/landingPageEventsApi';
import mapResultsToIndexPageItems from '@/pageGeneration/services/mapResultsToIndexPageItems';
import EventsIndexPage from '@/components/pageComponents/EventsIndexPage';
import useCustomPageViews from '@/utility/eventTracking/useCustomPageViews';
import { PAGE_CATEGORIES } from '@/utility/eventTracking/constants';
import UnprotectedPage from '@/components/navigation/UnprotectedPage';
import { ILandingPageLink } from '@/pageGeneration/services/LandingPageService';

interface IProps {
  items: ILandingPageLink[];
}

const EventsPage: FunctionComponent<IProps> = ({ items }) => {
  useCustomPageViews({ category: PAGE_CATEGORIES.EVENTS, name: 'List' });

  return (
    <UnprotectedPage>
      <PageSeo title="Events" noIndex />
      <BarHeaderLayout>
        <EventsIndexPage items={items} />
      </BarHeaderLayout>
    </UnprotectedPage>
  );
};

export async function getStaticProps() {
  let items: ILandingPageLink[];
  try {
    const results = await getLandingPageEvents();

    items = mapResultsToIndexPageItems(results, '/events/');

    return packageStaticProps({
      items,
    });
  } catch (e) {
    console.error(e);
    return {
      notFound: true,
    };
  }
}

export default EventsPage;
